import { createApiAction } from 'src/api';
import moment from 'moment';

export const FETCH_ACCOUNT_BACKGROUND_ASSESSMENTS_START =
  'background_assessments/fetch_account_background_assessments_start';
export const FETCH_ACCOUNT_BACKGROUND_ASSESSMENTS_SUCCESS =
  'background_assessments/fetch_account_background_assessments_success';
export const FETCH_ACCOUNT_BACKGROUND_ASSESSMENTS_FAILURE =
  'background_assessments/fetch_account_background_assessments_failure';

export const FETCH_BACKGROUND_ASSESSMENT_START =
  'background_assessments/fetch_background_assessment_start';
export const FETCH_BACKGROUND_ASSESSMENT_SUCCESS =
  'background_assessments/fetch_background_assessment_success';
export const FETCH_BACKGROUND_ASSESSMENT_FAILURE =
  'background_assessments/fetch_background_assessment_failure';

export const ADD_BACKGROUND_ASSESSMENT_START =
  'background_assessments/add_background_assessment_start';
export const ADD_BACKGROUND_ASSESSMENT_SUCCESS =
  'background_assessments/add_background_assessment_success';
export const ADD_BACKGROUND_ASSESSMENT_FAILURE =
  'background_assessments/add_background_assessment_failure';

export const FETCH_BACKGROUND_ASSESSMENT_TYPES_START =
  'background_assessments/fetch_background_assessment_types_start';
export const FETCH_BACKGROUND_ASSESSMENT_TYPES_SUCCESS =
  'background_assessments/fetch_background_assessment_types_success';
export const FETCH_BACKGROUND_ASSESSMENT_TYPES_FAILURE =
  'background_assessments/fetch_background_assessment_types_failure';

export const FETCH_BACKGROUND_ASSESSMENT_TYPE_RESULTS_START =
  'background_assessments/fetch_background_assessment_type_results_start';
export const FETCH_BACKGROUND_ASSESSMENT_TYPE_RESULTS_SUCCESS =
  'background_assessments/fetch_background_assessment_type_results_success';
export const FETCH_BACKGROUND_ASSESSMENT_TYPE_RESULTS_FAILURE =
  'background_assessments/fetch_background_assessment_type_results_failure';

export const UPDATE_BACKGROUND_ASSESSMENTS_START =
  'background_assessments/update_background_assessments_start';
export const UPDATE_BACKGROUND_ASSESSMENTS_SUCCESS =
  'background_assessments/update_background_assessments_success';
export const UPDATE_BACKGROUND_ASSESSMENTS_FAILURE =
  'background_assessments/update_background_assessments_failure';

export const UPDATE_BACKGROUND_ASSESSMENT_START =
  'background_assessments/update_background_assessment_start';
export const UPDATE_BACKGROUND_ASSESSMENT_SUCCESS =
  'background_assessments/update_background_assessment_success';
export const UPDATE_BACKGROUND_ASSESSMENT_FAILURE =
  'background_assessments/update_background_assessment_failure';

export const FETCH_BACKGROUND_ASSESSMENT_LOGS_START =
  'background_assessments/fetch_background_assessment_logs_start';
export const FETCH_BACKGROUND_ASSESSMENT_LOGS_SUCCESS =
  'background_assessments/fetch_background_assessment_logs_success';
export const FETCH_BACKGROUND_ASSESSMENT_LOGS_FAILURE =
  'background_assessments/fetch_background_assessment_logs_failure';

export const ADD_BACKGROUND_ASSESSMENT_LOG_START =
  'background_assessments/add_background_assessment_log_start';
export const ADD_BACKGROUND_ASSESSMENT_LOG_SUCCESS =
  'background_assessments/add_background_assessment_log_success';
export const ADD_BACKGROUND_ASSESSMENT_LOG_FAILURE =
  'background_assessments/add_background_assessment_log_failure';

export const FETCH_BACKGROUND_ASSESSMENT_LOG_TYPES_START =
  'background_assessments/fetch_background_assessment_log_types_start';
export const FETCH_BACKGROUND_ASSESSMENT_LOG_TYPES_SUCCESS =
  'background_assessments/fetch_background_assessment_log_types_success';
export const FETCH_BACKGROUND_ASSESSMENT_LOG_TYPES_FAILURE =
  'background_assessments/fetch_background_assessment_log_types_failure';

export const FETCH_COMPLIANCE_DASHBOARD_DATA_START =
  'background_assessments/fetch_compliance_dashboard_data_start';
export const FETCH_COMPLIANCE_DASHBOARD_DATA_SUCCESS =
  'background_assessments/fetch_compliance_dashboard_data_success';
export const FETCH_COMPLIANCE_DASHBOARD_DATA_FAILURE =
  'background_assessments/fetch_compliance_dashboard_data_failure';

export const FETCH_COMPLIANCE_HISTORY_START =
  'background_assessments/fetch_compliance_history_start';
export const FETCH_COMPLIANCE_HISTORY_SUCCESS =
  'background_assessments/fetch_compliance_history_success';
export const FETCH_COMPLIANCE_HISTORY_FAILURE =
  'background_assessments/fetch_compliance_history_failure';

export const FETCH_COMPLIANCE_SETTINGS_START =
  'background_assessments/fetch_compliance_settings_start';
export const FETCH_COMPLIANCE_SETTINGS_SUCCESS =
  'background_assessments/fetch_compliance_settings_success';
export const FETCH_COMPLIANCE_SETTINGS_FAILURE =
  'background_assessments/fetch_compliance_settings_failure';

export const UPDATE_COMPLIANCE_SETTINGS_START =
  'background_assessments/update_compliance_settings_start';
export const UPDATE_COMPLIANCE_SETTINGS_SUCCESS =
  'background_assessments/update_compliance_settings_success';
export const UPDATE_COMPLIANCE_SETTINGS_FAILURE =
  'background_assessments/update_compliance_settings_failure';

export const UPDATE_COMPLIANCE_SETTING_START =
  'background_assessments/update_compliance_setting_start';
export const UPDATE_COMPLIANCE_SETTING_SUCCESS =
  'background_assessments/update_compliance_setting_success';
export const UPDATE_COMPLIANCE_SETTING_FAILURE =
  'background_assessments/update_compliance_setting_failure';

export const UPDATE_COMPLIANCE_EMAILS_START =
  'background_assessments/update_compliance_emails_start';
export const UPDATE_COMPLIANCE_EMAILS_SUCCESS =
  'background_assessments/update_compliance_emails_success';
export const UPDATE_COMPLIANCE_EMAILS_FAILURE =
  'background_assessments/update_compliance_emails_failure';

export const FETCH_COMPLIANCE_NOTIFICATIONS_START =
  'background_assessments/fetch_compliance_notifications_start';
export const FETCH_COMPLIANCE_NOTIFICATIONS_SUCCESS =
  'background_assessments/fetch_compliance_notifications_success';
export const FETCH_COMPLIANCE_NOTIFICATIONS_FAILURE =
  'background_assessments/fetch_compliance_notifications_failure';

export const UPDATE_COMPLIANCE_NOTIFICATIONS_START =
  'background_assessments/update_compliance_notifications_start';
export const UPDATE_COMPLIANCE_NOTIFICATIONS_SUCCESS =
  'background_assessments/update_compliance_notifications_success';
export const UPDATE_COMPLIANCE_NOTIFICATIONS_FAILURE =
  'background_assessments/update_compliance_notifications_failure';

const processDate = (d, endOfDay = false) =>
  moment(d).format(`YYYY-MM-DD${endOfDay ? ' 23:59:59' : ' 00:00:00'}`);

export const fetchAccountBackgroundAssessments = ({ accountId }) =>
  createApiAction(
    {
      path: `/api/v1/accounts/${accountId}/background_assessments/`,
      method: 'GET',
    },
    [
      FETCH_ACCOUNT_BACKGROUND_ASSESSMENTS_START,
      FETCH_ACCOUNT_BACKGROUND_ASSESSMENTS_SUCCESS,
      FETCH_ACCOUNT_BACKGROUND_ASSESSMENTS_FAILURE,
    ]
  );

export const fetchComplianceDashboardData = ({
  accountId,
  financialInstitutionId,
  merchantIds,
  start,
  end,
}) =>
  createApiAction(
    {
      path: `/api/v1/background_assessments/${financialInstitutionId}/${
        accountId ? `${accountId}/` : ''
      }dashboard/`,
      method: 'POST',
      body: {
        ...(merchantIds
          ? { merchant_ids: merchantIds.map(id => parseInt(id, 10)) }
          : {}),
        startdate: processDate(start),
        enddate: processDate(end, true),
      },
    },
    [
      FETCH_COMPLIANCE_DASHBOARD_DATA_START,
      FETCH_COMPLIANCE_DASHBOARD_DATA_SUCCESS,
      FETCH_COMPLIANCE_DASHBOARD_DATA_FAILURE,
    ]
  );

export const fetchComplianceHistory = ({
  accountId,
  financialInstitutionId,
  merchantIds,
  start,
  end,
}) =>
  createApiAction(
    {
      path: `/api/v1/background_assessments/${financialInstitutionId}/${
        accountId ? `${accountId}/` : ''
      }overview/`,
      method: 'POST',
      body: {
        ...(merchantIds
          ? { merchant_ids: merchantIds.map(id => parseInt(id, 10)) }
          : {}),
        startdate: processDate(start),
        enddate: processDate(end, true),
      },
    },
    [
      FETCH_COMPLIANCE_HISTORY_START,
      FETCH_COMPLIANCE_HISTORY_SUCCESS,
      FETCH_COMPLIANCE_HISTORY_FAILURE,
    ]
  );

export const fetchBackgroundAssessment = backgroundAssessmentId =>
  createApiAction(
    {
      path: `/api/v1/background_assessments/${backgroundAssessmentId}/`,
      method: 'GET',
    },
    [
      FETCH_BACKGROUND_ASSESSMENT_START,
      FETCH_BACKGROUND_ASSESSMENT_SUCCESS,
      FETCH_BACKGROUND_ASSESSMENT_FAILURE,
    ]
  );

export const addBackgroundAssessment = ({
  account,
  user,
  location,
  backgroundAssessmentType,
}) =>
  createApiAction(
    {
      path: `/api/v1/background_assessments/initial`,
      method: 'POST',
      body: {
        background_assessment_account: account,
        background_assessment_user: user,
        background_assessment_location: location,
        background_assessment_type: backgroundAssessmentType,
      },
    },
    [
      ADD_BACKGROUND_ASSESSMENT_START,
      ADD_BACKGROUND_ASSESSMENT_SUCCESS,
      ADD_BACKGROUND_ASSESSMENT_FAILURE,
    ]
  );

export const updateBackgroundAssessmentSupplementalInformation = ({
  backgroundAssessmentId,
  supplementalInformation,
}) =>
  createApiAction(
    {
      path: `/api/v1/background_assessments/${backgroundAssessmentId}/`,
      method: 'PATCH',
      body: {
        background_assessment_supplemental_information: supplementalInformation,
      },
    },
    [
      UPDATE_BACKGROUND_ASSESSMENT_START,
      UPDATE_BACKGROUND_ASSESSMENT_SUCCESS,
      UPDATE_BACKGROUND_ASSESSMENT_FAILURE,
    ]
  );

export const acknowledgeBackgroundAssessment = ({ backgroundAssessmentId }) =>
  createApiAction(
    {
      path: `/api/v1/background_assessments/${backgroundAssessmentId}/`,
      method: 'PATCH',
      body: {
        background_assessment_acknowledged: true,
        background_assessment_resolved: false,
      },
    },
    [
      UPDATE_BACKGROUND_ASSESSMENT_START,
      UPDATE_BACKGROUND_ASSESSMENT_SUCCESS,
      UPDATE_BACKGROUND_ASSESSMENT_FAILURE,
    ]
  );

export const resolveBackgroundAssessment = ({ backgroundAssessmentId }) =>
  createApiAction(
    {
      path: `/api/v1/background_assessments/${backgroundAssessmentId}/`,
      method: 'PATCH',
      body: {
        background_assessment_acknowledged: true,
        background_assessment_resolved: true,
      },
    },
    [
      UPDATE_BACKGROUND_ASSESSMENT_START,
      UPDATE_BACKGROUND_ASSESSMENT_SUCCESS,
      UPDATE_BACKGROUND_ASSESSMENT_FAILURE,
    ]
  );

export const fetchBackgroundAssessmentTypes = () =>
  createApiAction(
    {
      path: `/api/v1/background_assessments/types/`,
      method: 'GET',
    },
    [
      FETCH_BACKGROUND_ASSESSMENT_TYPES_START,
      FETCH_BACKGROUND_ASSESSMENT_TYPES_SUCCESS,
      FETCH_BACKGROUND_ASSESSMENT_TYPES_FAILURE,
    ]
  );

export const fetchBackgroundAssessmentTypeResults = () =>
  createApiAction(
    {
      path: `/api/v1/background_assessments/types/results/`,
      method: 'GET',
    },
    [
      FETCH_BACKGROUND_ASSESSMENT_TYPE_RESULTS_START,
      FETCH_BACKGROUND_ASSESSMENT_TYPE_RESULTS_SUCCESS,
      FETCH_BACKGROUND_ASSESSMENT_TYPE_RESULTS_FAILURE,
    ]
  );

export const fetchBackgroundAssessmentLogs = ({ backgroundAssessmentId }) =>
  createApiAction(
    {
      path: `/api/v1/background_assessments/${backgroundAssessmentId}/logs/`,
      method: 'GET',
    },
    [
      FETCH_BACKGROUND_ASSESSMENT_LOGS_START,
      FETCH_BACKGROUND_ASSESSMENT_LOGS_SUCCESS,
      FETCH_BACKGROUND_ASSESSMENT_LOGS_FAILURE,
    ]
  );

export const addBackgroundAssessmentLog = ({
  backgroundAssessmentId,
  type,
  details,
  originator,
}) =>
  createApiAction(
    {
      path: `/api/v1/background_assessments/${backgroundAssessmentId}/logs/`,
      method: 'POST',
      body: {
        background_assessment_log_type: type,
        background_assessment_log_details: details,
        background_assessment_log_originator: originator,
      },
    },
    [
      ADD_BACKGROUND_ASSESSMENT_LOG_START,
      ADD_BACKGROUND_ASSESSMENT_LOG_SUCCESS,
      ADD_BACKGROUND_ASSESSMENT_LOG_FAILURE,
    ]
  );

export const fetchBackgroundAssessmentLogTypes = () =>
  createApiAction(
    {
      path: `/api/v1/background_assessments/logs/types/`,
      method: 'GET',
    },
    [
      FETCH_BACKGROUND_ASSESSMENT_LOG_TYPES_START,
      FETCH_BACKGROUND_ASSESSMENT_LOG_TYPES_SUCCESS,
      FETCH_BACKGROUND_ASSESSMENT_LOG_TYPES_FAILURE,
    ]
  );

export const fetchComplianceSettings = ({ financialInstitutionId }) =>
  createApiAction(
    {
      path: `/api/v1/background_assessments/${financialInstitutionId}/settings/`,
      method: 'GET',
    },
    [
      FETCH_COMPLIANCE_SETTINGS_START,
      FETCH_COMPLIANCE_SETTINGS_SUCCESS,
      FETCH_COMPLIANCE_SETTINGS_FAILURE,
    ]
  );

export const updateComplianceSettings = ({
  financialInstitutionId,
  enableAll,
  disableAll,
  addAllFIAdmin,
  addEmails,
  deleteEmails,
  taskFrequency,
  gratuityTolerance,
  taskType,
}) =>
  createApiAction(
    {
      path: `/api/v1/background_assessments/${financialInstitutionId}/settings/`,
      method: 'POST',
      body: {
        enable_all: enableAll || false,
        disable_all: disableAll || false,
        add_all_fi_emails: addAllFIAdmin || false,
        add_emails: addEmails || [],
        delete_emails: deleteEmails || [],
        task_frequency: taskFrequency || null,
        gratuity_tolerance: gratuityTolerance || null,
        task_type: taskType,
      },
    },
    [
      UPDATE_COMPLIANCE_SETTINGS_START,
      UPDATE_COMPLIANCE_SETTINGS_SUCCESS,
      UPDATE_COMPLIANCE_SETTINGS_FAILURE,
    ]
  );

export const updateComplianceSetting = ({
  financialInstitutionId,
  isActive,
  addEmails,
  deleteEmails,
  taskFrequency,
  gratuityTolerance,
  taskId,
}) =>
  createApiAction(
    {
      path: `/api/v1/background_assessments/${financialInstitutionId}/settings/${taskId}`,
      method: 'PUT',
      body: {
        task_is_active: isActive,
        add_emails: addEmails || [],
        delete_emails: deleteEmails || [],
        task_frequency: taskFrequency || null,
        gratuity_tolerance: gratuityTolerance || null,
      },
    },
    [
      UPDATE_COMPLIANCE_SETTING_START,
      UPDATE_COMPLIANCE_SETTING_SUCCESS,
      UPDATE_COMPLIANCE_SETTING_FAILURE,
    ]
  );

export const updateComplianceEmails = ({
  financialInstitutionId,
  data,
  taskId,
}) =>
  createApiAction(
    {
      path: `/api/v1/background_assessments/${financialInstitutionId}/emails/${taskId}`,
      method: 'PUT',
      body: data,
    },
    [
      UPDATE_COMPLIANCE_EMAILS_START,
      UPDATE_COMPLIANCE_EMAILS_SUCCESS,
      UPDATE_COMPLIANCE_EMAILS_FAILURE,
    ]
  );

export const fetchComplianceNotifications = ({
  financialInstitutionId,
  userId,
}) =>
  createApiAction(
    {
      path: `/api/v1/background_assessments/${financialInstitutionId}/notifications/${userId}`,
      method: 'GET',
    },
    [
      FETCH_COMPLIANCE_NOTIFICATIONS_START,
      FETCH_COMPLIANCE_NOTIFICATIONS_SUCCESS,
      FETCH_COMPLIANCE_NOTIFICATIONS_FAILURE,
    ]
  );

export const updateComplianceNotifications = ({
  financialInstitutionId,
  userId,
  data,
}) =>
  createApiAction(
    {
      path: `/api/v1/background_assessments/${financialInstitutionId}/notifications/${userId}`,
      method: 'PUT',
      body: data,
    },
    [
      UPDATE_COMPLIANCE_NOTIFICATIONS_START,
      UPDATE_COMPLIANCE_NOTIFICATIONS_SUCCESS,
      UPDATE_COMPLIANCE_NOTIFICATIONS_FAILURE,
    ]
  );
